import React, { useEffect, useState } from 'react';
import LoadingChart from '@/features/dashboard/components/LoadingChart';
import ColumnChartComPorcentagem from '@/components/Base/ColumnChartInadimplenciaAcumulo';
import { generateLastYears } from './CashFlowTela';
import PeriodFilterDash from '@/components/Base/PeriodFilterDash';
import { useEvolucaoInadimplencia } from './api/getEvolucaoInadimplencia';

const ScoreInadimplenciaEvolucao = ({ year, month }) => {
  const filters = {
    ...(year && { year: year }),
    ...(month && { month: month }),
  };

  const { data, isFetched, isFetching } = useEvolucaoInadimplencia(filters);

  const selectedData = data?.valor_meses.length ? data : null;

  return (
    <>
      {selectedData && <ColumnChartComPorcentagem selectedData={selectedData} title={'Evolução da inadimplência'} firstColor={'#e04a4c'} secondColor={'#f6be33'} columnOne={'Total recebido'} columnTwo={'Total a receber'} percentageName={'Evolução da inadimplência'}/>}
    </>
  );
};

export default ScoreInadimplenciaEvolucao;
